import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import logo from '../assets/chip_logo.png';
import '../styles/Login.css';

const Login = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);

  const Toast = {
    show: ({ type, text1 }) => alert(`[${type.toUpperCase()}] ${text1}`)
  };

  const validateEmail = (em) => /\S+@\S+\.\S+/.test(em);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const cleanedEmail = email.trim();

    if (!cleanedEmail) {
      setErrors({ email: "Email cannot be empty" });
      return;
    }

    if (!validateEmail(cleanedEmail)) {
      setErrors({ email: "Invalid email format" });
      return;
    }

    if (!password.trim()) {
      setErrors({ password: "Password cannot be empty" });
      return;
    }

    try {
      setLoader(true);
      const { data } = await api.post("/admin/auth/login", {
        email: cleanedEmail,
        password: password.trim()
      });

      const token = data?.access_token || data?.accessToken;

      if (token) {
        localStorage.setItem('access_token', token);
        if (data?.user) {
          localStorage.setItem('user_details', JSON.stringify(data.user));
        }
        onLoginSuccess();
        navigate('/');
      } else {
        Toast.show({
          type: "error",
          text1: data?.error ?? "Login failed. Please try again."
        });
      }
    } catch (error) {
      const message = error?.response?.data?.error ?? error?.message ?? "Login failed. Please try again.";
      Toast.show({ type: "error", text1: message });
    } finally {
      setLoader(false);
    }
  };
 
  return (
    <div className="app-container">
      <header className="login-header">
        <div className="logo-container">
          <img src={logo} alt="Chip Logo" className="logo" />
        </div>
      </header>

      <main className="login-main-content">
        <div className="login-card">
          <h1>Admin sign-in</h1>
          <p className="subtitle">Round Up. Chip Away. Eliminate Debt.</p>

          <form className="form-group" onSubmit={handleSubmit} noValidate>
            <div>
              <div className="input-container">
                <svg className="input-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <input 
                  type="email" 
                  placeholder="Email" 
                  className={`input-field ${errors.email ? 'input-error' : ''}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {errors.email && <p className="error-text">{errors.email}</p>}
            </div>

            <div>
              <div className="input-container">
                <svg className="input-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Password" 
                  className={`input-field ${errors.password ? 'input-error' : ''}`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <svg className="input-icon-right" onClick={() => setShowPassword(!showPassword)} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {showPassword ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
                  )}
                </svg>
              </div>
              {errors.password && <p className="error-text">{errors.password}</p>}
            </div>

            <div className="forgot-password" onClick={() => navigate('/forgot-password')} style={{ cursor: 'pointer' }}>Forgot password?</div>

            <button type="submit" className="submit-btn" disabled={loader}>
              {loader ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Login;
